import React from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

export default function Navbar() {
    return (
        <nav className="navbar">
            <div className="nav-container">
                <ul className="nav-links">
                    <li><Link to="/about">About Us</Link></li>
                    <li><Link to="/download">Download Catalogue</Link></li>
                    <li><Link to="/rawcast">New Creation</Link></li>
                    <li><Link to="/cadcam">CAD/CAM Master Model</Link></li>
                    <li><Link to="/register">Register</Link></li>
                    <li><Link to="/contact">Contact Us</Link></li>
                </ul>
            </div>
        </nav>
    );
}
